import * as actionTypes from 'constants/ActionTypes';
import _ from 'lodash';

const vessel = (state = { errors: [] }, action) => {
    switch (action.type) {
    case actionTypes.CLEAR_VESSEL:
        return {
            errors: [],
        };
    case actionTypes.SAVE_VESSEL:
        return {
            ...action.vessel,
        };
    case actionTypes.GET_VESSEL.REQUEST:
        return {
            errors: [],
        };
    case actionTypes.GET_VESSEL.SUCCESS: {
        const vessel = _.cloneDeep(action.data);
        const holds = vessel.holds;
        const hatches = vessel.hatches;

        if (holds.lowerDims.length === 0) {
            vessel.holds.lowerDims = new Array(holds.quantity).fill({});
        }

        vessel.holds.lowerDims = holds.lowerDims.concat(new Array(holds.quantity - holds.lowerDims.length).fill({}));

        if (holds.tweenDims.length === 0) {
            vessel.holds.tweenDims = new Array(holds.quantity).fill({});
        }

        vessel.holds.tweenDims = holds.tweenDims.concat(new Array(holds.quantity - holds.tweenDims.length).fill({}));

        if (hatches.size.length === 0) {
            vessel.hatches.size = new Array(hatches.quantity).fill({});
        }

        if (hatches.quantity < hatches.size.length) {
            hatches.quantity = hatches.size.length;
        }

        vessel.hatches.size = hatches.size.concat(new Array(hatches.quantity - hatches.size.length).fill({}));

        return {
            errors: [],
            ...vessel,
        };
    }
    case actionTypes.GET_VESSEL.FAILURE:
        return {
            ...state,
            errors: action.errors,
        };
    case actionTypes.DELETE_NAME_SUGGESTION.REQUEST:
        return {
            ...state,

            ...action.vessel,

            errors: [],
        };

    case actionTypes.DELETE_NAME_SUGGESTION.SUCCESS: {
        return {
            ...state,

            ...action.vessel,

            errors: [],
        };
    }

    case actionTypes.DELETE_NAME_SUGGESTION.FAILURE:
        return {
            ...state,

            ...action.vessel,

            errors: action.errors,
        };

    case actionTypes.RENAME_VESSEL.REQUEST:
        return {
            ...state,

            ...action.vessel,

            errors: [],
        };

    case actionTypes.RENAME_VESSEL.SUCCESS: {
        return {
            ...state,

            ...action.vessel,

            errors: [],
        };
    }

    case actionTypes.RENAME_VESSEL.FAILURE:
        return {
            ...state,

            ...action.vessel,

            errors: action.errors,
        };
    case actionTypes.UPDATE_VESSEL.REQUEST:
        return {
            ...state,
            ...action.vessel,
            errors: [],
        };
    case actionTypes.UPDATE_VESSEL.SUCCESS: {
        return {
            ...state,
            ...action.vessel,
            errors: [],
        };
    }
    case actionTypes.PATCH_VESSEL_FIELDS.SUCCESS: {
        return {
            ...state,
            ...action.fields,
            errors: [],
        };
    }
    case actionTypes.PATCH_VESSEL_FIELDS.FAILURE: {
        return {
            ...state,
            errors: action.errors,
        };
    }
    case actionTypes.UPDATE_VESSEL.FAILURE:
        return {
            ...state,
            ...action.vessel,
            errors: action.errors,
        };
    case actionTypes.DELETE_VESSEL.REQUEST:
        return {
            ...state,
            errors: [],
        };
    case actionTypes.DELETE_VESSEL.SUCCESS: {
        return {
            ...state,
            ...action.vessel,
            errors: [],
        };
    }
    case actionTypes.DELETE_VESSEL.FAILURE:
        return {
            ...state,
            ...action.vessel,
            errors: action.errors,
        };
    case actionTypes.ADD_VESSEL.REQUEST:
        return {
            ...state,
            ...action.vessel,
            errors: [],
        };
    case actionTypes.ADD_VESSEL.SUCCESS: {
        return {
            ...state,
            ...action.vessel,
            errors: [],
        };
    }
    case actionTypes.ADD_VESSEL.FAILURE:
        return {
            ...state,
            ...action.vessel,
            errors: action.errors,
        };
    case actionTypes.CONFIRM_VESSEL.REQUEST:
        return {
            ...state,
            errors: [],
        };
    case actionTypes.CONFIRM_VESSEL.SUCCESS: {
        return {
            ...state,
            ...action.data,
            errors: [],
        };
    }
    case actionTypes.CONFIRM_VESSEL.FAILURE:
        return {
            ...state,
            errors: action.errors,
        };

    case actionTypes.UPDATE_VESSEL_IMAGE.REQUEST:
        return {
            ...state,
            errors: [],
        };
    case actionTypes.UPDATE_VESSEL_IMAGE.SUCCESS: {
        return {
            ...state,
            ...action.data,
            errors: [],
        };
    }
    case actionTypes.UPDATE_VESSEL_IMAGE.FAILURE:
        return {
            ...state,
            errors: action.errors,
        };
    default:
        return state;
    }
};

export default vessel;



// WEBPACK FOOTER //
// ./app/reducers/vessels/vessel.js